import { render } from "./BillRow.vue?vue&type=template&id=ba7c779c&scoped=true&ts=true"
import script from "./BillRow.vue?vue&type=script&lang=ts"
export * from "./BillRow.vue?vue&type=script&lang=ts"

import "./BillRow.vue?vue&type=style&index=0&id=ba7c779c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7c779c"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
